export default "/Frontend/dist/download-icon.79302a1ab1a3542a6c50a2cc258be20e.svg";